/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class PrinterPickAssistant extends Assistant {
        bc_menu = document.createElement("div");
        submit_button: HTMLElement;
        submit_button_text: HTMLElement;
        callback: () => void;
        constructor() {
            super();
            this.bc_menu.innerHTML = `
                <h1>${SP.Localize("text_print_all_label_headline")}</h1>
                <center><img src="/terminal/img/scan.png"></center>
                <br />
                <div class="btn noselect grad-green"><span class="action"></span></div>
            `; 

            this.submit_button = this.bc_menu.querySelector(".btn");
            this.submit_button_text = this.submit_button.querySelector(".action");
            this.submit_button.addEventListener("click", () => {
                this.callback();
                this.close();
            });

            this.container.appendChild(this.bc_menu);
        }


        hide() {
            this.bc_menu.style.display = "none";
        }

        open_bc() {
            this.hide();
            this.container.style.display = "block";
            this.bc_menu.style.display = "block";
        }

        clear() {
            //clear home buttons
            this.container.style.display = "none";
        }

        bound = false;

        async open(closeBtnText: string, callback: () => void) {


            this.submit_button_text.innerHTML = closeBtnText;

            this.callback = callback;
            this.open_bc();


            if (!this.bound) {
                barcodeListener.on("print", this.scanPrinter, this);
                this.bound = true;
            }
        }




        close() {
            if (this.bound) {
                barcodeListener.off(null, this.scanPrinter);
                this.bound = false;
            }
            super.close();
        }

        scanPrinter(printerName: string) {
            selectPrinter(printerName);
            this.submit_button.click();
            return false;
        }
    }


}